import {Component, input} from '@angular/core';
import {ElciaIcon} from '../icon/icon';

@Component({
  selector: 'elcia-expander-icon',
  imports: [
    ElciaIcon
  ],
  templateUrl: './expander-icon.html',
  styleUrl: './expander-icon.scss',
})
export class ExpanderIcon {
  isExpanded = input.required<boolean>();
}
